import "./Navbar.css";
import logo from "../assets/logo.png";
import { useEffect, useState } from "react";

const Navbar = ({ solid = false }) => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallBtn, setShowInstallBtn] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallBtn(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstallClick = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then(() => {
        setDeferredPrompt(null);
        setShowInstallBtn(false);
      });
    }
  };

  const p = solid ? "/" : "";
  const links = [
    { href: `${p}#packages`, label: "Packages" },
    { href: `${p}#stays`, label: "Stays" },
    { href: `${p}#cab`, label: "Cab" },
    { href: `${p}#sightseeing`, label: "Sightseeing" },
    { href: `${p}#reviews`, label: "Reviews" },
    { href: "/listings", label: "Listings" },
    { href: "/partner", label: "Partner" },
  ];
  const close = () => setMenuOpen(false);

  return (
    <div className={`Navbar-container${solid ? " solid" : ""}`}>
      <a href="/" className="Navbar-brand" onClick={close}>
        <img src={logo} alt="OotyGo" id="Nav-logo" />
      </a>

      <button
        className={`Navbar-toggle${menuOpen ? " open" : ""}`}
        onClick={() => setMenuOpen((o) => !o)}
        aria-label="Toggle menu"
        aria-expanded={menuOpen}
      >
        <span /><span /><span />
      </button>

      <nav className={`Navbar${menuOpen ? " open" : ""}`}>
        <ul className="Navbar-links">
          {links.map((l) => (
            <li key={l.label}>
              <a href={l.href} onClick={close}>{l.label}</a>
            </li>
          ))}
          {showInstallBtn && (
            <li className="Navbar-install-mobile">
              <button onClick={() => { handleInstallClick(); close(); }} className="App-btn">📲 Install App</button>
            </li>
          )}
        </ul>
      </nav>

      <div className="Navbar-cta">
        {showInstallBtn && (
          <button onClick={handleInstallClick} className="App-btn">📲 Install OotyGo App</button>
        )}
      </div>

      {menuOpen && <div className="Navbar-backdrop" onClick={close} />}
    </div>
  );
};

export default Navbar;
